import React from 'react';
import { CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_PRESSED_LIGHT } from '@oneaudi/unified-web-common';

const BackArrow: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="05 Icons/01 Small/Directions/arrow-straight-up-large">
      <rect width="24" height="24" transform="translate(0 24) rotate(-90)" />
      <path
        id="Mask"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.70718 13L6.35363 16.6464L5.64652 17.3535L0.792969 12.5L5.64652 7.64641L6.35363 8.35352L2.70718 12L24.0001 12L24.0001 13L2.70718 13Z"
        fill="black"
      />
      <mask
        id="mask0"
        // eslint-disable-next-line react/no-unknown-property
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="7"
        width="24"
        height="11"
      >
        <path
          id="Mask_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.70718 13L2.20718 12.5L2.70718 12L24.0001 12L24.0001 13L2.70718 13ZM2.70718 13L6.35363 16.6464L5.64652 17.3535L0.792969 12.5L5.64652 7.64641L6.35363 8.35352L2.70718 12L1.50008 12L1.50008 13L2.70718 13Z"
          fill={CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_PRESSED_LIGHT}
        />
      </mask>
      <g mask="url(#mask0)">
        <g id="Colors/Icons/">
          <rect
            id="Rectangle"
            y="24"
            width="24"
            height="24"
            transform="rotate(-90 0 24)"
            fill={CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_PRESSED_LIGHT}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default BackArrow;
